export enum PerfChannel {
  HTTP = 'HTTP',
  NAV = 'NAV',
  ADVICE = 'ADVICE',
}

export enum PerfSuggestionCode {
  DUPLICATE_REQUEST = 'DUPLICATE_REQUEST',
  SLOW_SERVER_RESPONSE = 'SLOW_SERVER_RESPONSE',
  LARGE_PAYLOAD = 'LARGE_PAYLOAD',
  SLOW_FAILURE = 'SLOW_FAILURE',
  REQUEST_WATERFALL = 'REQUEST_WATERFALL',
  CHATTY_NAVIGATION = 'CHATTY_NAVIGATION',
  NAVIGATION_BLOCKED_BY_HTTP = 'NAVIGATION_BLOCKED_BY_HTTP',
  NAVIGATION_WITHOUT_NETWORK = 'NAVIGATION_WITHOUT_NETWORK',
}

export interface IPerfSuggestion {
  readonly code: PerfSuggestionCode;
  readonly message: string;
}

export interface IHttpPerfSample {
  readonly method: string;
  readonly url: string;
  /** `performance.now()` when the request started. */
  readonly startMs: number;
  /** `performance.now()` when the request settled. */
  readonly endMs: number;
  /** 0 when the request never got a response (network error, abort). */
  readonly status: number;
  /** Undefined when the response size could not be determined cheaply. */
  readonly sizeBytes?: number;
}

export interface INavigationPerfSample {
  readonly url: string;
  readonly startMs: number;
  readonly endMs: number;
}
